import PropTypes from "prop-types";
import { Box, Grid, Typography } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Form from "@accredo/fe-shared/components/Form/Form.jsx";
import FormTextField from "../Form/controls/FormTextField.jsx";
import SubmitButton from "@accredo/fe-shared/components/Form/controls/SubmitButton.jsx";
import DsButton from "@accredo/fe-shared/theme/components/Button.jsx";
import FormDatePicker from "../Form/controls/FormDatePicker.jsx";

const validationSchema = yup.object({
  betreff: yup.string().required("Betreff/Titel ist erforderlich"),
  beschreibung: yup.string().required("Beschreibung ist erforderlich"),
});

const NoteForm = ({ defaultValues, onSubmit, onCancel, disabled }) => {
  return (
    <Form
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      resolver={yupResolver(validationSchema)}
      mode="onChange"
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}></Grid>
        </Grid>

        <Typography variant="body2" color="text.secondary">
          Nur für Sie selber und Mitarbeiter in Ihrem Unternehmen sichtbar
        </Typography>

        <FormTextField
          name="betreff"
          label="Betreff/Titel"
          fullWidth
          disabled={disabled}
        />

        <FormTextField
          name="beschreibung"
          label="Beschreibung"
          fullWidth
          multiline
          rows={12}
          disabled={disabled}
        />

        {/* Reminder Due Date */}
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormDatePicker
              name="faellig_am"
              label="Erinnern am"
              disabled={disabled}
              clearable={true}
            />
          </Grid>
          {/*<Grid size={{ xs: 12, md: 6 }}>*/}
          {/*  <QuickDateButtons disabled={disabled} />*/}
          {/*</Grid>*/}
        </Grid>

        <Box
          sx={{ display: "flex", gap: 2, justifyContent: "flex-end", pt: 1 }}
        >
          <DsButton variant="tertiary" onClick={onCancel}>
            {disabled ? "Schließen" : "Abbrechen"}
          </DsButton>
          {!disabled && <SubmitButton>Speichern</SubmitButton>}
        </Box>
      </Box>
    </Form>
  );
};

NoteForm.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default NoteForm;
